export const FINANCE_VENDOR_CREATE = 'FINANCE_VENDOR_CREATE';
export const FINANCE_VENDOR_LIST_READ = 'FINANCE_VENDOR_LIST_READ';

export const VENDOR_READ = 'READ';
export const VENDOR_UPDATE = 'UPDATE';
export const VENDOR_UPDATE_PRIVILEGED_INFO = 'UPDATE_PRIVILEGED_INFO';
export const VENDOR_REJECT = 'REJECT';
export const VENDOR_COMPLIANCE_REVIEW = 'COMPLIANCE_REVIEW';
export const VENDOR_FINALIZE = 'FINALIZE';
export const FINANCE_VENDOR_AGREEMENT_FINALIZE = 'FINALIZE';
export const FINANCE_VENDOR_AGREEMENT_TERMINATE = 'TERMINATE';
export const FINANCE_VENDOR_AGREEMENT_UPDATE = 'UPDATE';

export enum VENDOR_PROFILE_STATUSES {
  DRAFT = 'DRAFT',
  APPROVED = 'APPROVED',
  FINALIZED = 'FINALIZED',
}
export const VENDOR_PROFILE_STATUSES_VALUES = {
  [VENDOR_PROFILE_STATUSES.DRAFT]: 'Draft',
  [VENDOR_PROFILE_STATUSES.APPROVED]: 'Approved',
  [VENDOR_PROFILE_STATUSES.FINALIZED]: 'Finalized',
};

export enum VENDOR_WORKING_STATUSES {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}
export const VENDOR_WORKING_STATUSES_VALUES = {
  [VENDOR_WORKING_STATUSES.ACTIVE]: 'Active',
  [VENDOR_WORKING_STATUSES.INACTIVE]: 'Inactive',
};

export const AGREEMENT_TYPES = {
  CONTRACT: 'CONTRACT',
  PUBLIC_OFFER: 'PUBLIC_OFFER',
};
export const AGREEMENT_TYPES_VALUES = {
  [AGREEMENT_TYPES.CONTRACT]: 'Contract',
  [AGREEMENT_TYPES.PUBLIC_OFFER]: 'Public offer',
};

export const VENDOR_DURACTION_TYPE = {
  FIXED_TERM: 'FIXED_TERM',
  OPEN_ENDED: 'OPEN_ENDED',
  ONE_TIME: 'ONE_TIME',
};
export const VENDOR_DURACTION_TYPE_VALUES = {
  [VENDOR_DURACTION_TYPE.FIXED_TERM]: 'Fixed term',
  [VENDOR_DURACTION_TYPE.OPEN_ENDED]: 'Open ended',
  [VENDOR_DURACTION_TYPE.ONE_TIME]: 'One time',
};

export const AGREEMENT_STATUS = {
  DRAFT: 'DRAFT',
  ACTIVE: 'ACTIVE',
  EXPIRED: 'EXPIRED',
  TERMINATED: 'TERMINATED',
};
